// LIBRERIE/IMPORTS
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import PropertySearchField from "../../Home/Search";
import NotFound from "../../Error/NotFound";

// CONFIG
const LARGE_FILES_URL = import.meta.env.VITE_LARGE_FILES_BASE_URL;


interface SubHeaderHomeProps {
    agencyName?: string;
    isSeo: boolean;
    showSearchForm?: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({
    showSearchForm = true // Default a true se non specificato
}) => {

    const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);
    const { t } = useTranslation();

    // Transizione per rendere visibile il text wrapper
    const [boxVisible, setBoxVisible] = useState(false);

    useEffect(() => {
        const handleVisible = () => {
        setBoxVisible(true)
        };
        
        const timer = setTimeout( handleVisible, 2000);
        return () => clearTimeout(timer);
    },[])

    // Rendering Componente
    if (loading) return <LoadingIndicator />;
    if (error) return <SlowLoadComponent />;
    if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

    return (
        <section className="banner">
            <video autoPlay muted loop playsInline>
                <source src={`${LARGE_FILES_URL}/videoHero.mp4`} type="video/mp4" />
            </video>
            <div className={`text-wrapper ${boxVisible ? 'visible' : ''}`}>
                <h1 dangerouslySetInnerHTML={{ __html: t('homePage.hero.title') as string }} />
                {showSearchForm && <PropertySearchField searchData={{}} />}
            </div>
        </section>
    );
};

export default SubHeaderHome;